import SEOHead from "@/components/SEOHead";
import Layout from "@/components/Layout";
import HeroSection from "@/components/HeroSection";
import TrustSection from "@/components/TrustSection";
import ProductWorldsSection from "@/components/ProductWorldsSection";
import ProductSpotlightSection from "@/components/ProductSpotlightSection";
import SelectionGuideSection from "@/components/SelectionGuideSection";
import ExperienceSection from "@/components/ExperienceSection";
import HowToSection from "@/components/HowToSection";
import CashbackDiscountSection from "@/components/CashbackDiscountSection";
import FAQSection from "@/components/FAQSection";
import FinalCTASection from "@/components/FinalCTASection";
import ExpertSection from "@/components/ExpertSection";
import DisclosureSection from "@/components/DisclosureSection";

// A/B-Test beendet (24.05.2026). Sieger: Variante A (CTR 14,3 % vs. 11,1 % bei
// besserer Position) – Title/Description fest verdrahtet, seo-experiments.ts entfernt.
const PAGE_TITLE = "heilys Rabattcode LONGEVITY – 5 % Rotlichttherapie-Discount 2026";
const PAGE_DESCRIPTION =
  "heilys Erfahrungen, Test & Rabattcode LONGEVITY ➜ 5 % sofort auf alle Rotlichttherapie-Geräte. Direkt im Checkout, ohne Cashback-Portal, ohne Wartezeit.";

const faqStructuredData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Gibt es aktuell einen heilys Rabattcode?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, aktuell ist der heilys Rabattcode LONGEVITY verfügbar. Mit diesem Code erhalten Nutzer nach aktuellem Stand 5 % Rabatt auf das gesamte heilys Sortiment. Der Code kann direkt im Checkout des offiziellen heilys Shops eingelöst werden.",
      },
    },
    {
      "@type": "Question",
      name: "Wie funktioniert der Code LONGEVITY?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Kopiere den Code LONGEVITY, öffne den heilys Shop über den Partnerlink und lege deine gewünschten Produkte in den Warenkorb. Im Checkout-Bereich gibt es ein Feld für Rabattcodes – dort fügst du LONGEVITY ein und der Rabatt wird automatisch abgezogen.",
      },
    },
    {
      "@type": "Question",
      name: "Für welche Produkte gilt der Rabatt?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Nach aktuellem Stand gilt der heilys Rabattcode LONGEVITY für das gesamte Sortiment im offiziellen heilys Shop – also für Rotlichtpanels, kompakte Lampen, Wearables und Zubehör.",
      },
    },
    {
      "@type": "Question",
      name: "Ist heilys.info der offizielle heilys Shop?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Nein. heilys.info ist eine unabhängige Informationsseite und hat keine direkte Verbindung zum Unternehmen heilys. Wir betreiben keinen eigenen Shop und verkaufen keine Produkte.",
      },
    },
    {
      "@type": "Question",
      name: "Welche heilys Produkte sind für Einsteiger interessant?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Für Einsteiger in die Rotlichttherapie für zuhause eignen sich in der Regel kompakte Geräte oder kleinere Panels, da sie einen überschaubaren Einstieg bieten und einfach zu handhaben sind.",
      },
    },
    {
      "@type": "Question",
      name: "Worauf sollte man bei Rotlichtgeräten achten?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Wichtige Faktoren bei der Auswahl eines Rotlichtgeräts sind der geplante Einsatzbereich, die Größe des Geräts, die Flexibilität im Alltag und die Verarbeitungsqualität. Typische Wellenlängen sind 630–660 nm für sichtbares Rotlicht und 810–850 nm für Nahinfrarot.",
      },
    },
    {
      "@type": "Question",
      name: "Wie lange ist der Rabattcode gültig?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Der Code LONGEVITY ist nach aktuellem Stand aktiv und funktionsfähig. Eine feste Angabe zur Gültigkeitsdauer können wir als unabhängige Informationsseite nicht garantieren, da die Laufzeit vom Anbieter heilys festgelegt wird.",
      },
    },
    {
      "@type": "Question",
      name: "Lässt sich der Code mit anderen Aktionen kombinieren?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ob der Code LONGEVITY mit anderen Rabattaktionen oder Gutscheinen kombiniert werden kann, hängt von den aktuellen Bedingungen im heilys Shop ab. Wir empfehlen, den Code im Checkout einzugeben und zu prüfen, ob er mit laufenden Aktionen kompatibel ist.",
      },
    },
    {
      "@type": "Question",
      name: "Wie schnell liefert heilys nach Deutschland, Österreich und in die Schweiz?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "heilys versendet nach aktuellem Stand aus Deutschland, wodurch Lieferungen innerhalb Deutschlands in der Regel innerhalb weniger Werktage eintreffen. Für Österreich und die Schweiz kann die Lieferzeit je nach Versandart etwas länger ausfallen.",
      },
    },
    {
      "@type": "Question",
      name: "Was ist der Unterschied zwischen Rotlicht und Nahinfrarot bei heilys Geräten?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sichtbares Rotlicht (630–660 nm) wird für oberflächennahe Anwendungen wie Haut und Gesicht genutzt. Nahinfrarotlicht (810–850 nm) dringt tiefer ins Gewebe ein und wird für Muskeln, Gelenke und tieferliegende Strukturen eingesetzt. Viele heilys Geräte kombinieren beide Wellenlängen.",
      },
    },
    {
      "@type": "Question",
      name: "Gibt es heilys Cashback oder einen Discount-Code?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ein klassisches Cashback-Programm bietet heilys nach aktuellem Stand nicht an. Stattdessen ist der Rabattcode LONGEVITY verfügbar, der 5 % Rabatt auf das gesamte Sortiment im heilys Shop gewährt. Der Code funktioniert wie ein Discount-Code und wird direkt im Checkout eingelöst – die Ersparnis wird sofort vom Bestellwert abgezogen.",
      },
    },
    {
      "@type": "Question",
      name: "Wie sind die heilys Gen30 Erfahrungen?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Das heilys Gen30+Vision ist ein kompaktes Rotlichtgerät mit 36 Dual-Chip-LEDs, 30 W und sechs Wellenlängen (630, 660, 670, 810, 830, 850 nm). Erste Erfahrungen mit dem Gen30 fallen positiv aus – besonders gelobt werden der Vision-Modus mit 670 nm (laut Hersteller ohne Schutzbrille nutzbar), die kompakte Bauform für gezielte Anwendungen sowie die niedrigen EMF-Werte und der flimmerfreie Betrieb. Für Ganzkörperanwendungen sind größere heilys Panels besser geeignet.",
      },
    },
    {
      "@type": "Question",
      name: "Heißt es heilys oder hailys?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Die korrekte Schreibweise der Marke ist heilys (mit „ei\"). Häufige Tippfehler wie „hailys\", „heylis\" oder „heilis\" beziehen sich in der Regel auf dieselbe Marke der weCare+ GmbH aus Bielefeld. Auf heilys.info nutzen wir konsequent die offizielle Schreibweise heilys.",
      },
    },
    {
      "@type": "Question",
      name: "Gibt es einen heilys Gutschein oder Gutscheincode?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, der heilys Gutscheincode LONGEVITY ist nach aktuellem Stand der einzige öffentlich kommunizierte Gutschein. Er wirkt im Checkout wie ein klassischer Gutschein und reduziert den Bestellwert um 5 % – gültig auf das gesamte heilys Sortiment.",
      },
    },
    {
      "@type": "Question",
      name: "Was bedeutet heilys Discount und wie funktioniert er?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Mit „heilys Discount\" ist in der Regel der Rabattcode LONGEVITY gemeint, der 5 % Discount auf alle heilys Rotlichttherapie-Geräte gewährt. Im Gegensatz zu Cashback-Portalen wird der Rabatt direkt im Checkout vom Bestellwert abgezogen – ohne Wartezeit, ohne Account bei einem Drittanbieter.",
      },
    },
    {
      "@type": "Question",
      name: "Welche heilys Erfahrungen gibt es bisher?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Öffentlich verfügbare Erfahrungen mit heilys fallen überwiegend positiv aus: Auf Trustpilot bewerten Käufer die Marke mit rund 4,3/5 Sternen (Stand 2026). Positiv erwähnt werden die Verarbeitungsqualität, der Versand aus Deutschland sowie die Beratung. Unsere eigene Einordnung zum Gen30+ Vision findest du auf der Detailseite.",
      },
    },
  ],
};

// Article ist die kanonische Page-Entity für die Startseite (Review-/Übersichts­artikel).
// Bewusst KEIN HowTo-Schema mehr: Google rendert HowTo seit 2023 nicht mehr als Rich Result
// und kann es bei kommerziellen Coupon-Inhalten als Spam-Signal werten.
// Bewusst KEIN separates WebPage-Schema: würde mit Article kollidieren.
const articleStructuredData = {
  "@context": "https://schema.org",
  "@type": "Article",
  "@id": "https://heilys.info/#article",
  headline: "heilys Rabattcode & Rotlichttherapie-Discount: 5 % mit LONGEVITY",
  description:
    "Aktueller heilys Rabattcode LONGEVITY für 5 % Rotlichttherapie-Discount – inkl. Cashback-Alternative, Gen30+Vision-Einordnung, Trustpilot-Score und unabhängiger Produktübersicht.",
  image: [
    "https://heilys.info/images/hero-main.webp",
    "https://heilys.info/images/heilys_4.webp",
    "https://heilys.info/images/heilys_3.webp",
  ],
  datePublished: "2026-01-15",
  dateModified: "2026-06-25",
  inLanguage: "de",
  url: "https://heilys.info/",
  mainEntityOfPage: "https://heilys.info/",
  author: {
    "@type": "Person",
    name: "Benedikt Keck",
    jobTitle: "Longevity-Experte",
    url: "https://www.longevity-hackers.de/about",
    worksFor: {
      "@type": "Organization",
      name: "Longevity Hackers",
      url: "https://www.longevity-hackers.de/",
    },
  },
  publisher: {
    "@type": "Organization",
    name: "heilys.info",
    url: "https://heilys.info/",
    logo: {
      "@type": "ImageObject",
      url: "https://heilys.info/favicon.png",
      width: 180,
      height: 180,
    },
  },
  about: { "@type": "Brand", name: "heilys" },
  mentions: [
    { "@type": "Product", name: "heilys Gen30+ Vision" },
    { "@type": "Thing", name: "Rotlichttherapie" },
    { "@type": "Thing", name: "Photobiomodulation" },
  ],
};

const breadcrumbStructuredData = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Startseite",
      item: "https://heilys.info/",
    },
  ],
};

const Index = () => (
  <Layout>
    <SEOHead
      title={PAGE_TITLE}
      description={PAGE_DESCRIPTION}
      canonical="https://heilys.info/"
      ogImage="https://heilys.info/images/hero-main.webp"
      ogImageAlt="heilys Rabattcode LONGEVITY – 5 % Rotlichttherapie-Discount mit Cashback-Alternative"
      // Hinweis: WebSite + Organization sind sitewide statisch in index.html.
      // Hier nur die zur Seite gehörenden Schemas: Article (Page-Entity),
      // Breadcrumb (Navigation), FAQPage (sichtbare Q&A im DOM).
      schemaJson={[articleStructuredData, breadcrumbStructuredData, faqStructuredData]}
    />
    <HeroSection />
    <TrustSection />
    <ProductWorldsSection />
    <ProductSpotlightSection />
    <SelectionGuideSection />
    <ExperienceSection />
    <HowToSection />
    <CashbackDiscountSection />
    <FAQSection />
    <FinalCTASection />
    <ExpertSection />
    <DisclosureSection />
  </Layout>
);

export default Index;
